import { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

/**
 * Stable React/dnd-kit keys for a list whose items have no id of their own (plain strings, or
 * objects that are replaced on every edit). The caller reports removals and moves; appends and
 * external resets are picked up from the length.
 */
export const useRowKeys = (length: number) => {
  const [keys, setKeys] = useState(() => Array.from({ length }, () => uuidv4()));

  if (keys.length !== length) {
    setKeys(Array.from({ length }, (_, i) => keys[i] ?? uuidv4()));
  }

  return {
    keyAt: (index: number) => keys[index] ?? `pending-${index}`,
    remove: (index: number) => setKeys(keys.filter((_, i) => i !== index)),
    move: (from: number, to: number) => {
      const next = [...keys];
      next.splice(to, 0, ...next.splice(from, 1));
      setKeys(next);
    },
  };
};
